module.exports = __webpack_public_path__ + "img/login.029f07f1.png";